import { IFormResponses, IFormSubmissionsReadonly } from '@llws/lift-entity-interfaces';
import {
  convertQueryCommandToQueryString, Equal, In, IQueryCommandOptions, Not, Null,
} from '@llws/dynamic-router-utils';
import { ActionContext } from 'vuex';
import { StoreBaseImplementationV2 } from '@/shared/classes/store-base-implementation-v2';
import { adminRequest } from '@/shared/request-configs/admin-request';

// Base store configuration
const adminGatewayResourcePath: string = '/website-api/form_submissions_readonly';
const listViewName: string = '';
const showLogging: boolean = false;

const defaultGetListFilters: IQueryCommandOptions = {};

const defaultGetSingleFilters: IQueryCommandOptions = {};

// Instantiate the base store with the params
const base = new StoreBaseImplementationV2<IFormSubmissionsReadonly>({
  adminGatewayResourcePath,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
});

// Extend StoreBaseImplementation object to add custom state/getters/mutations/actions.
export default {
  namespaced: base.namespaced, // 'form-submissions-readonly/'

  state: {
    ...base.state,
    formNames: null,
  },

  getters: {
    ...base.getters,

    availableFormNames(state: (typeof base.state & { formNames?: string[] })): string[] {
      return [...state.formNames || []];
    },
  },

  mutations: {
    ...base.mutations,

    setFormNames(state: (typeof base.state & { formNames?: string[] }), payload: string[]) {
      state.formNames = payload;
    },
  },

  actions: {
    search: base.actions.search,

    getCSV: base.actions.getCSV,

    getFormNames: async (
      ctx: ActionContext<IFormSubmissionsReadonly, (typeof base.state)>,
      payload: { websiteId: number, status: IFormSubmissionsReadonly['status'] },
    ) => {
      const query = {
        alias: 'fsr',
        selectDistinct: 'fsr.formId',
        where: [ Not(Null('fsr.formId')) ],
        limit: 999,
      };

      const result = await adminRequest.post<{ formId: number }[], null>('/v1/website-api/form_submissions_readonly/_search', query);

      const formsQuery = convertQueryCommandToQueryString({
        alias: 'fs',
        where: [
          In('fs.id', result.data?.map((form) => form.formId) ?? []),
        ],
        orderBy: [
          { field: 'fs.name', direction: 'asc' },
        ],
        limit: 999,
      });

      const forms = await adminRequest.get<IFormResponses[]>(`/v1/website-api/sites/${payload.websiteId}/form_settings${formsQuery}`);
      ctx.commit('setFormNames', forms.data?.map((data) => data.name) ?? []);
    },
  },
};
